<template>
  <div>
    <van-row>
      <van-col :span="18">
        <base-input v-model="queryCondition.payer" label="抬头名称" />
      </van-col>
      <van-col :span="6" style="padding-top: 5px;">
        <base-button type="primary" @click="query">刷新</base-button>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="24" class="tip-msg">
        提示：点击记录，可查看发票明细及修改发票状态！
      </van-col>
    </van-row>
    <van-row class="list-title">
      <van-col span="6">抬头名称</van-col>
      <van-col span="4">发票类型</van-col>
      <van-col span="4">状态</van-col>
      <van-col span="4">总金额</van-col>
      <van-col span="6">创建时间</van-col>
    </van-row>
    <template v-if="data && data.length > 0">
      <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="query">
        <van-cell v-for="item in data" :key="item.id" class="list-tip"
                  @click="handleClick(item)">
          <van-col span="6" style="text-align: center;">{{ item.payer }}</van-col>
          <van-col span="4" style="text-align: center;">{{ item.type_name }}</van-col>
          <van-col span="4" style="text-align: center;">{{ item.status_name }}</van-col>
          <van-col span="4" style="text-align: center;">{{ item.amount }}</van-col>
          <van-col span="6" style="text-align: center;">{{ item.create_time }}</van-col>
        </van-cell>
      </van-pull-refresh>
      <van-tabbar safe-area-inset-bottom>
        <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="query()" />
      </van-tabbar>
    </template>
    <template v-else>
      <van-col span="24" class="list-tip">{{ tip }}</van-col>
    </template>
  </div>
</template>

<script>
import { getInvoiceList } from '@/api/invoice'
export default {
  name: 'InvoiceManage',
  data() {
    return {
      loading: false,
      data: [],
      tip: this.CONST.EMPTY_MSG,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',

        payer: ''
      }
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    query() {
      this.tip = '查询中...'
      this.loading = true
      getInvoiceList(this.queryCondition).then(resp => {
        this.data = resp.rows || [];
        this.data.forEach(row => {
          row.type_name = this.CONST.INVOICE_TYPE.find(item => item.id === row.type).name;
          row.handover_type_name = this.CONST.INVOICE_HANDOVER_TYPE.find(item => item.id === row.handover_type).name;
          row.status_name = this.CONST.INVOICE_STATUS.find(item => item.id === row.status).name;
          row.create_time = row.create_time.substring(0, 10);
        })
        this.queryCondition.total = resp.total || 0;
        if (this.data.length === 0) {
          this.tip = this.CONST.EMPTY_MSG
        }
        this.loading = false;
      }).catch(() => {
        this.tip = this.CONST.EMPTY_MSG;
      })
    },
    modifyStatus(value) {
      console.log(value)
    },
    handleClick(invoice) {
      this.$store.dispatch('app/setSelectedInvoice', invoice)
      this.$router.push('/invoice/invoice-edit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoice/manage.vue